<div class="page-not-found-container relative flex flex-col min-h-screen w-full h-full">
    <div class="content">=
        <h1 class="error-code flex flex-col justify-center items-center">404
            <span class="watermark" aria-hidden="true">404</span>
        </h1>

        <div class="teal-bar my-12"></div>

        <h2 class="title">Page introuvable</h2>

        <p class="description">
            Désolé, la page que vous recherchez n&apos;existe pas ou a été déplacée.
        </p>
    </div>
</div>